import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { PageResponse } from '@models/api';
import { PartnerProductResponse, getPartnerProduct } from '@apis/product';

export const usePartnerProductDetail = (productId: number) => {
  const queryOptions: UseQueryOptions<
    PageResponse<PartnerProductResponse>,
    Error
  > = {
    queryKey: ['partnerProductDetail', productId],
    queryFn: () => {
      return getPartnerProduct(productId);
    },
    refetchOnMount: 'always',
  };
  return useQuery(queryOptions);
};
